import { Component, ChangeDetectionStrategy, ChangeDetectorRef, computed, inject, input } from '@angular/core';
import { MenuItem } from '@openng/optimus-ui/api';
import { ButtonModule } from '@openng/optimus-ui/button';
import { TieredMenu, TieredMenuModule } from '@openng/optimus-ui/tieredmenu';

@Component({
  selector: 'ui-context-menu',
  imports: [TieredMenuModule, ButtonModule],
  templateUrl: './context-menu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ContextMenuComponent<TRow = unknown> {
  private readonly cdr = inject(ChangeDetectorRef);

  /** Hotové položky menu. */
  readonly rowActions = input<MenuItem[]>();
  /** Alternativa k `rowActions`: řádek a funkce, která z něj položky vytvoří (přehledy s tabulkou). */
  readonly row = input<TRow>();
  readonly actionsFor = input<(row: TRow) => MenuItem[]>();
  /** Třídy (utility) kořene menu v overlayi, např. minimální šířka; menu se vykresluje do body. */
  readonly menuStyleClass = input<string>();

  readonly model = computed<MenuItem[]>(() => {
    const actions = this.rowActions();
    if (actions) return actions;
    const row = this.row();
    const actionsFor = this.actionsFor();
    return actionsFor && row !== undefined ? actionsFor(row) : [];
  });

  /**
   * Otevře nebo zavře menu a hned ho vykreslí. Bez zone.js by se položky objevily až při příštím naplánovaném
   * průchodu detekce změn, ne ve stejné úloze jako klik (jako dřív se zone.js); e2e testy čtou položky hned po kliku.
   */
  protected toggle(menu: TieredMenu, event: Event): void {
    menu.toggle(event);
    this.cdr.detectChanges();
  }
}
